<template>
  <component :is='tag' v-bind:style="{ fontSize: $store.getters.fontSize + 'px' }">
    <slot></slot>
  </component>
</template>

<script>
export default { props:['tag'] };
</script>
